import { render, staticRenderFns } from "./OptimizationCardRightSidePanel.vue?vue&type=template&id=50b298f5&scoped=true&"
import script from "./OptimizationCardRightSidePanel.vue?vue&type=script&lang=ts&"
export * from "./OptimizationCardRightSidePanel.vue?vue&type=script&lang=ts&"
import style0 from "./OptimizationCardRightSidePanel.vue?vue&type=style&index=0&id=50b298f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b298f5",
  null
  
)

export default component.exports